import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../lib/api';

export interface OutreachStats {
  recentSendsCount: number;
  replyRate: number;
  bounceRate: number;
  activeQueuesCount: number;
  recentMessages: RecentMessage[];
}

export interface RecentMessage {
  id: string;
  contactId: string;
  pressListId: string | null;
  subject: string | null;
  toEmail: string;
  status: string;
  sentAt: string | null;
  openCount: number;
  replyReceivedAt: string | null;
  createdAt: string;
  contactFirstName: string | null;
  contactLastName: string | null;
  pressListName: string | null;
}

export interface MessageDetail {
  id: string;
  userId: string;
  contactId: string;
  pressListId: string | null;
  emailAccountId: string | null;
  sendBatchId: string | null;
  subject: string | null;
  bodyHtml: string | null;
  bodyText: string | null;
  toEmail: string;
  status: string;
  scheduledAt: string | null;
  sentAt: string | null;
  openedAt: string | null;
  openCount: number;
  threadId: string | null;
  messageId: string | null;
  inReplyTo: string | null;
  replySubject: string | null;
  replyBodyText: string | null;
  replyFromEmail: string | null;
  replyReceivedAt: string | null;
  failureReason: string | null;
  retryCount: number;
  createdAt: string;
  updatedAt: string;
  contactFirstName?: string | null;
  contactLastName?: string | null;
  contactImageUrl?: string | null;
}

export interface MessageDetailResponse {
  message: MessageDetail;
  thread: MessageDetail[];
}

export function useOutreachStats() {
  return useQuery({
    queryKey: ['outreach-stats'],
    queryFn: () => apiGet<OutreachStats>('/messages/stats'),
    refetchInterval: 30_000,
  });
}

export function useMessageDetail(id: string | null) {
  return useQuery({
    queryKey: ['message-detail', id],
    queryFn: () => apiGet<MessageDetailResponse>(`/messages/${id}`),
    enabled: !!id,
  });
}
